var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideNavigationAdminManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.0396H7C3.83 21.0396 1.25 18.4596 1.25 15.2896V5.70961C1.25 4.40961 1.85 3.95961 2.21 3.80961C2.57 3.65961 3.31 3.54961 4.23 4.46961L6.82 7.05961C6.92 7.15961 7.08 7.15961 7.17 7.05961L10.76 3.46961C11.42 2.80961 12.58 2.80961 13.23 3.46961L16.82 7.05961C16.92 7.15961 17.08 7.15961 17.17 7.05961L19.76 4.46961C20.68 3.54961 21.42 3.66961 21.78 3.80961C22.14 3.95961 22.74 4.39961 22.74 5.70961V15.2996C22.75 18.7296 20.44 21.0396 17 21.0396ZM2.81 5.23961C2.78 5.31961 2.75 5.46961 2.75 5.70961V15.2996C2.75 17.6396 4.66 19.5496 7 19.5496H17C19.58 19.5496 21.25 17.8796 21.25 15.2996V5.70961C21.25 5.46961 21.22 5.32961 21.19 5.24961C21.11 5.28961 20.99 5.36961 20.82 5.53961L18.23 8.12961C17.57 8.78961 16.41 8.78961 15.76 8.12961L12.17 4.53961C12.07 4.43961 11.91 4.43961 11.82 4.53961L8.24 8.11961C7.58 8.77961 6.42 8.77961 5.77 8.11961L3.18 5.52961C3.01 5.35961 2.88 5.27961 2.81 5.23961Z",
    fill: "#0D0706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavigationAdminManagementIcon);
export default __webpack_public_path__ + "static/media/side-navigation-admin-management-icon.da6d3f08d04dafe37d75ffb610ce8b94.svg";
export { ForwardRef as ReactComponent };